<pages-container
  [title]="'main.calendar'"
  [icon]="'today'"
  [showFilter]="true">
  <div buttons class="calendar-buttons">
    <button class="calendar-button ics-button" (click)="copyCalendarUrl()">
      <img class="ics" src="assets/images/icons/ics.svg">
      <input id="calendarUrl"
             value="https://pfeffersternbackendapilive.ibexfusion.com/event/getMyCalendar?type=back&user={{userId()}}">
    </button>
    <button class="calendar-button" (click)="setView(CalendarView.Day)" [class.active]="view() === CalendarView.Day">
      <mat-icon>view_day</mat-icon>
    </button>
    <button class="calendar-button" (click)="setView(CalendarView.Week)" [class.active]="view() === CalendarView.Week">
      <mat-icon>view_week</mat-icon>
    </button>
    <button class="calendar-button" (click)="setView(CalendarView.Month)" [class.active]="view() === CalendarView.Month">
      <mat-icon>view_module</mat-icon>
    </button>
  </div>

  <app-filter filter-content [page]="'event'" [filters]="filterData()"
              [filterFromDB]="userFiltersFromDB()" (chooseFilter)="chooseFilters($event)"></app-filter>

  <div main-content class="calendar-container">
    <div class="calendar-buttons">
      <button mwlCalendarPreviousView [view]="view()" [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button mwlCalendarToday [(viewDate)]="viewDate">
        <h3>{{ viewDate | calendarDate: view() + 'ViewTitle' : 'en' }}</h3>
      </button>
      <button mwlCalendarNextView [view]="view()" [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <div class="calendar">
      @switch (view()) {
        @case (CalendarView.Month) {
          <mwl-calendar-month-view [viewDate]="viewDate" [events]="events()"
                                   (eventClicked)="editEvent($event.event)"
                                   (dayClicked)="dayHeaderClicked($event)"/>
        }
        @case (CalendarView.Week) {
          <mwl-calendar-week-view [viewDate]="viewDate" [events]="events()"
                                  (eventClicked)="editEvent($event.event)"
                                  (dayHeaderClicked)="dayHeaderClicked($event)"/>
        }
        @case (CalendarView.Day) {
          <mwl-calendar-day-view [viewDate]="viewDate" [events]="events()"
                                 (eventClicked)="editEvent($event.event)"/>
        }
      }
    </div>
  </div>
</pages-container>
